module.exports = __webpack_public_path__ + "img/jurnal.f2adb673.png";